import { apiPost } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IUser } from "./getMe";

// 학생 생성 요청 인터페이스
export interface ICreateStudentRequest {
  email: string;
  password: string;
  name: string;
  grade?: number;
  is_graduated?: boolean;
  school?: string;
  phone?: string;
  parent_phone?: string;
  memo?: string;
  group_id?: string;
}

// 학생 생성 API 함수
export const apiCreateStudent = async (data: ICreateStudentRequest) => {
  const response = await apiPost<IUser>("/users", {
    ...data,
    role: "student", // 항상 학생 역할로 생성
  });
  return response;
};

// 학생 생성 React Query 훅
export const useCreateStudent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiCreateStudent,
    onSuccess: () => {
      // 사용자 목록 데이터 갱신
      queryClient.invalidateQueries({ queryKey: QueryKeys.user.all });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user.list() });
    },
  });
};

export default useCreateStudent;
